var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.053 5.849a1 1 0 011.225.707l.668 2.491a.75.75 0 01-1.45.388l-.246-.922a8.5 8.5 0 005.987 11.803 8.5 8.5 0 005.224-.553.751.751 0 01.612 1.37A10 10 0 012.976 7.69l-1.025.275a.75.75 0 01-.388-1.448l2.49-.668zM8.279 2.718a10 10 0 0113.665 8.231 9.999 9.999 0 01-1.026 5.57l1.006-.268a.75.75 0 01.388 1.448l-2.491.668a1 1 0 01-1.225-.707l-.667-2.49a.75.75 0 011.449-.389l.254.955a8.5 8.5 0 00-1.32-9.43A8.504 8.504 0 008.527 4.24l-.071.029a.75.75 0 01-.541-1.398l.364-.154z",
    fill: "currentColor"
  })));
}
SvgRefresh.displayName = 'Refresh';
export default SvgRefresh;